// services/wsrService.ts

import {
  UPLOAD_WSR_FILE_URL,
  LIST_WSR_FILES_URL,
  DOWNLOAD_WSR_FILE_URL,
} from "../config/constants";
import { requestNotificationsRefresh } from "./notificationsApi";
import { apiFetch } from "../utils/apiClient";


const getAuthHeader = ()=> {
  const rawToken =
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("authToken") ||
    sessionStorage.getItem("accessToken");

  const tokenType = sessionStorage.getItem("tokenType") || "Bearer";

  if (!rawToken) {
    throw new Error("Authentication token not found. Please log in again.");
  }

  const normalizedToken = rawToken
    .replace(/^"|"$/g, "")
    .replace(/^Bearer\s+/i, "")
    .trim();

  return `${tokenType} ${normalizedToken}`;
};

const extractErrorMessage = async (
  response,
  fallbackMessage
) => {
  try {
    const data = await response.json();

    if (typeof data?.message === "string" && data.message.trim()) {
      return data.message;
    }
  } catch {
    // Ignore parsing failure
  }

  return fallbackMessage;
};

export const wsrService = {
  async uploadWsrFile(projectId, file) {
    const formData = new FormData();
    formData.append("file", file);

    const response = await apiFetch(UPLOAD_WSR_FILE_URL(projectId), {
      method: "POST",
      headers: {
        Authorization: getAuthHeader(),
      },
      body: formData,
    }, "Failed to upload WSR file.");

    if (!response.ok) {
      throw new Error(
        await extractErrorMessage(response, "Failed to upload WSR file.")
      );
    }

    const data = await response.json();
    // STATUS_REPORT_UPLOADED
    requestNotificationsRefresh();
    return data.data;
  },

  async listWsrFiles(projectId) {
    const response = await apiFetch(LIST_WSR_FILES_URL(projectId), {
      method: "GET",
      headers: {
        Authorization: getAuthHeader(),
        Accept: "application/json",
      },
    }, "Failed to load WSR files.");

    if (!response.ok) {
      throw new Error(
        await extractErrorMessage(response, "Failed to load WSR files.")
      );
    }

    const data = await response.json();
    return (data.data) || [];
  },

  async downloadWsrFile(projectId, fileId, fileName) {
    const response = await apiFetch(DOWNLOAD_WSR_FILE_URL(projectId, fileId), {
      method: "GET",
      headers: {
        Authorization: getAuthHeader(),
      },
    }, "Failed to download WSR file.");

    if (!response.ok) {
      throw new Error(
        await extractErrorMessage(response, "Failed to download WSR file.")
      );
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};
